<script>
  import Dashboard from './Dashboard.svelte';
</script>

<h5>&nbsp;> Home</h5>
<br />

<Dashboard />
